
export enum KnowledgeSourceMode {
  upload = 'upload',
  url = 'url',
}

export interface Knowledge {
  id?: string;
  agentId?: string;
  name: string;
  sourceMode: KnowledgeSourceMode;
  files: { [key: string]: Blob };
  url?: string;
  maxCrawlingPage?: number;
  meta: string;
}

export function knowledgeToLocal(res: any) {
  return {
    id: res.id,
    agentId: res.agent_id,
    name: res.name,
    sourceMode: res.source_mode,
    files: res.files,
    url: res.url,
    meta: res.meta,
    maxCrawlingPage: res.max_crawling_page
  };
}

export function knowledgeToServer(data: Knowledge) {
  return {
    id: data.id,
    agent_id: data.agentId,
    name: data.name,
    source_mode: data.sourceMode,
    files: data.files,
    url: data.url,
    meta: data.meta,
    max_crawling_page: data.maxCrawlingPage
  };
}
